<template>
    <div class="timeline is-centered">
      <div class="timeline-item" v-for="historicoTarefa in historicosTarefa" :key="historicoTarefa.id" :style="`--color: ${historicoTarefa.cor}`" :class="{'active': (!!isActive[historicoTarefa.id] && isActive[historicoTarefa.id] == true) || isLayoutTouch}">
        <div class="timeline-marker is-image is-32x32">
          <TrfFotoUsuario class="mr-3" :fotoID="historicoTarefa.foto" :isRounded="true" :useTooltip="false" :height="32" :width="32"/>
        </div>
        <div>
          <span class="tooltiptext">
              {{ historicoTarefa?.responsavel?.nome ?  historicoTarefa.responsavel.nome : "Sem responsável"}}
        </span>
        </div>
        <div class="timeline-content card-content trf-is-hidden">
          <div class="card-container mt-3">
            <header class="card-head">
              <p class="card-head-title">{{ historicoTarefa.dataDaAcao + ' - ' + historicoTarefa.acao}}</p>
            </header>
            <div class="card-body content">
                <div v-if="!!isActive[historicoTarefa.id] && isActive[historicoTarefa.id] == true">
                <div class="content" v-html="descricaoHTML(historicoTarefa.descricaoAcao)"></div>
                <a @click="event => toggleCard(event, historicoTarefa.id)" title="Reduzir conteúdo">Reduzir conteúdo.</a>
              </div>
              <div v-else>
                <p>{{ HTMLStringToPlainText(historicoTarefa.descricaoAcao, 108) }}</p>
                <p><a @click="event => toggleCard(event, historicoTarefa.id)" title="Expandir conteúdo">Expandir.</a></p>
              </div>
              <div>
                <TrfButton v-if="this.deveExibirBtnDeExclusaoDeComentario(historicoTarefa.acao, historicoTarefa.responsavel)"
                  id="btn-excluir-comentario"
                  @click="(e) => this.abrirModalDeletarComentario(historicoTarefa, e)"
                  type="button"
                  :disabled="deveDesabilitarIconeTarefaDeAtendimento()"
                  :title="deveDesabilitarIconeTarefaDeAtendimento()? `Tarefa cadastrada em Atendimentos não permite exclusão de comentários.` : ``"
                  :temIcon="true"
                  class="button is-small pr-1 pb-0"
                  classIcon="mdi-delete mdi-18px"
                  style="border:none; background-color: transparent; float: right; right: -5px; bottom: 28px;"
                  :style="deveDesabilitarIconeTarefaDeAtendimento()? 'cursor: not-allowed' : 'cursor: pointer'"
                  />
                  <TrfButton v-if="this.deveExibirBtnDeEdicaoDeComentario(historicoTarefa.acao, historicoTarefa.responsavel)"
                  id="btn-editar-comentario"
                  @click="(e) => this.detalhesEdicaoComentario(historicoTarefa,e)"
                  type="button"
                  :disabled="historicoTarefa.possuiParecerAtendimento"
                  :title="historicoTarefa.possuiParecerAtendimento? `Tarefa cadastrada em Atendimentos não permite edição de comentários.` : ``"
                  :temIcon="true"
                  class="button is-small pr-1 pb-0"
                  classIcon="mdi-pencil mdi-18px"
                  style="border:none; background-color: transparent; float: right; right: -12px; bottom: 28px;"
                  :style="historicoTarefa.possuiParecerAtendimento? 'cursor: not-allowed' : 'cursor: pointer'"
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <TrfModal
        v-if="isModalDeletarComentarioActive"
        idModal="excluir-comentario"
        :titulo="tituloExclusao"
        btnSaveName="Confirmar"
        :isBtnLoading="isModalDeletarComentarioLoading"
        @save="this.delete"
        @close="fecharModalDeletarComentario"
      >
      <p class="card-content:" v-html="textoExclusao"></p><br />
    </TrfModal>
  </template>
  
  <script>
  import TrfFotoUsuario from '../Usuario/FotoUsuario.vue'
  import {layoutStore} from '../../stateManagement/layout.js'
  import TrfModal from '../Modal/index.vue' ;
  import { timelineTarefasService } from "../../service/timeline-tarefas-service";
  import { acessoUtils } from '../../util/acesso.utils';
  import TrfButton from "../Button";

  export default {
    name: "TrfTimeline",
    components: {
      TrfFotoUsuario,
      TrfModal,
      TrfButton
    },
    props: {
      tituloExclusao: {
        type: String,
        default: "Excluir comentário",
      },
      textoExclusao: {
        type: String,
        default: "Deseja excluir este comentário?",
      },
      historicosTarefa: {
        type: Object
      },
      tarefa: {
        type: Object
      },
      filtros: {
        type: Object
      },
      objetoEdicaoTarefa : {
        type: Object
      }
    },
    emits: ['carregaHistorico','edicaoComentario','limpaCampos'],
    data() {
      return {
        isActive: [],
        isModalDeletarComentarioActive: false,
        comentarioParaDeletar: null,
        comentarioParaEditar: null,
        isModalDeletarComentarioLoading: false,
        operadorLogadoId: null,
        itemHistorico:null
      }
    },
    computed: {
      isLayoutTouch() {
        return layoutStore.resolucaoTouch
      },
      adicionarAtributosObjetoEdicao() {
        const objetoEdicaoTarefaComId = { ...this.objetoEdicaoTarefa };
        objetoEdicaoTarefaComId.id = this.itemHistorico.id;
        objetoEdicaoTarefaComId.acao = this.itemHistorico.acao;
        objetoEdicaoTarefaComId.possuiParecerAtendimento = this.itemHistorico.possuiParecerAtendimento;
        return objetoEdicaoTarefaComId;
      },
    },
    methods: {
      descricaoHTML(descricao) {
        return descricao;
      },
      toggleCard(event, id) {
        this.isActive[id] = !this.isActive[id];
      },
      closeAllCards() {
        this.isActive = this.isActive.map(value => {
          return false;
        })
      },
      isHTML(conteudo) {
        const regex = new RegExp(/<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i);
        return regex.test(conteudo);
      },
      isAcimaDoLimiteDeExibicao(texto, limiteDeExibicao) {
        return texto.length > limiteDeExibicao;
      },
      HTMLStringToPlainText(htmlString, trim = 0) {
        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlString;

        let plainText = tempDiv.textContent || tempDiv.innerText || "";

        if(trim > 0 && !isNaN(trim) && plainText.length > trim) {
          plainText = plainText.substring(0,trim);
          plainText = plainText.substring(0,Math.min(plainText.length, plainText.lastIndexOf(" ")));
          plainText = `${plainText}...`;
          plainText = plainText.trim();
        }

        return plainText;
      },

      deveExibirBtnDeExclusaoDeComentario(acao, responsavel) {
        return (acao == "Comentário" || acao == "Comentário interno") && responsavel.id == this.operadorLogadoId;
      },

      deveExibirBtnDeEdicaoDeComentario(acao, responsavel) {
        return (acao == "Comentário" || acao == "Comentário interno") && responsavel.id == this.operadorLogadoId;
      },

      abrirModalDeletarComentario(item) {
        this.comentarioParaDeletar = item;
        this.isModalDeletarComentarioActive = true;
      },

      fecharModalDeletarComentario() {
        this.isModalDeletarComentarioActive = false;
        this.comentarioParaDeletar = null;
        this.isModalDeletarComentarioLoading = false;
      },
      async delete() {
        this.isModalDeletarComentarioLoading = true;

        let request = await timelineTarefasService.deletarComentario(this.comentarioParaDeletar);
        
        if (request.ok) {
          this.$emit("carregaHistorico")
        };

        this.isModalDeletarComentarioActive = false;
        this.isModalDeletarComentarioLoading = false;
        this.fecharModalDeletarComentario();
      },
      deveDesabilitarIconeTarefaDeAtendimento() {
        return this.tarefa.nome.includes("Atendimento: ");
      },
      async buscarOperadorLogado() {
        const operador = await acessoUtils.adquirirOperadorLogado();
        this.operadorLogadoId = operador.data.id;
      },
      async detalhesEdicaoComentario(item) {
        this.itemHistorico = item;
        this.$emit("edicaoComentario",item);
      },
      async alterarComentario() {
        const objetoEdicaoTarefa = this.adicionarAtributosObjetoEdicao;
        const request = await timelineTarefasService.editarComentario(objetoEdicaoTarefa);
        if(request.ok) {
          this.$emit("carregaHistorico");
          this.$emit("limpaCampos");
        }
      }
    },
    async created() {
      this.buscarOperadorLogado();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "bulma";
  @import "~bulma-timeline";
  .trf-is-hidden {
    overflow:hidden;
  }
  .card-container {
    box-shadow: 0px 2px 4px -4px grey;
    text-align: left;
    margin-left: 25px;
    margin-right: 10px;
    width: 170px;
    @media screen and (max-width: 1000px) {
      width: 100px;
    }
  }
  .timeline-item:nth-of-type(2n) .card-container {
    margin-right: 25px;
    margin-left: 10px;
  }
  .card-head {
    border-bottom: 1px solid var(--color);
    background: var(--color);
    padding: 2px 5px;
  }
  .timeline-item:nth-of-type(2n+1) .card-container::before {
    content: "";
    position: absolute;
    height: 0;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    filter: drop-shadow(0px 0px 1px grey);
    border-right: 20px solid var(--color);
    left: 30px;
  }
  .timeline-item:nth-of-type(2n) .card-container::before {
    content: "";
    position: absolute;
    height: 0;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    filter: drop-shadow(0px 0px 1px grey);
    border-left: 20px solid var(--color);
    right: 30px;
  }
  .tooltiptext {
    visibility: hidden;
    width: 140px;
    background-color: #fff;
    box-shadow: 0 2px 15px rgb(50 50 93 / 10%), 0 2px 15px rgb(0 0 0 / 7%);
    text-align: center;
    padding: 5px 5px;
    position: absolute;
    z-index: 1;
    margin-left: -170px;
    top: 20px;
    opacity: 0.7;
    border-radius: 5px;
  }
  img:hover, #btn-excluir-comentario:hover,#btn-editar-comentario:hover {
    cursor: pointer;
  }
  .timeline-marker:hover + div .tooltiptext {
    visibility: visible;
  }
  .timeline-item:nth-of-type(2n) .tooltiptext {
    margin-left: 30px;
  }
  .timeline-item:nth-of-type(2n) .tooltiptext {
    margin-right: -130px;
  }
  .card-body {
    padding: 5px;
    background: white;
    min-height: auto;
    border: 1px solid var(--color);
  }
  .timeline.is-centered .timeline-item {
    transition: width 0.25s ease 0s;
    .timeline-marker.is-image.is-32x32, .timeline-content.card-content, .card-container, .card-container:before, .card-body {
      transition: width 0.25s ease 0s;
    }
  }

  .timeline.is-centered .timeline-item.active {
    width: 100%;
    flex-direction: column;
    &:before {
      top: 0;
      left: 50%;
    };
    .timeline-marker.is-image.is-32x32 {
      position: relative;
      align-self: center;
    }
    .timeline-content.card-content {
      width: 100%;
      margin-left: 0;
      padding-left: 0;
    }
    .card-container {
      &:before {
        @media screen and (max-width: 1023px) {
          opacity:0;
        }
      }
      width: calc(100% - 35px);
      position: relative;
      margin-top: 38px!important;
      @media screen and (max-width: 1023px) {
        margin-top: 16px!important;
      }
    }

  }
  .timeline.is-centered .timeline-item:nth-child(odd).active {
    .timeline-marker.is-image.is-32x32 {
      margin-left: 2.25em;
    }
    .timeline-content.card-content {
      width: 100%;
      margin-left: 0;
      padding-left: 0;
    }
    .card-container {
      margin-left: 18px;
      &:before {
        left: 50%;
        transform: translateX(-50%) rotate(90deg);
        top: -25px;
        transition: 0.25s ease 0s;
      }
    }

  }
  .timeline.is-centered .timeline-item:nth-child(even).active {
    .timeline-marker.is-image.is-32x32 {
      margin-left: -2.25em;
    }
    .timeline-content.card-content {
      width: 100%;
      margin-right: 0;
      padding-right: 0;
    }
    .card-container {
      margin-right: 18px;
      &:before {
        left: 50%;
        transform: translateX(-50%) rotate(-90deg);
        top: -115px;
        transition: 0.25s ease 0s;
      }
    }
  }
  </style>